import storeModuleFactory from 'util/storeModule/storeModuleFactory';
import endpoints from 'config/endpoints';
import {TIMEOUT_STORE, TIMESTAMP_MULTIPLY} from 'util/constants';

module.exports = {
    createFetchParams: startDate => ({
        date: Math.floor(startDate / TIMESTAMP_MULTIPLY)
    }),
    ...storeModuleFactory({
        name:               'itsmSummaryTicketsLast12',
        endpoint:           endpoints.itsm.summaryTicketsLast12,
        timeout:            TIMEOUT_STORE.TIMEOUT_STORE_BIG,
        transformResultsFn: response => ({
            results: !response.results ? [] : response.results.map(item => ({
                period:             item.period,
                troubleTotalOpened: item.trouble_total_open,
                troubleTotalClosed: item.trouble_total_closed,
                requestTotalOpened: item.request_total_open,
                requestTotalClosed: item.request_total_closed
            }))
        })
    })
};



// WEBPACK FOOTER //
// ./src/modules/store/itsmSummaryTicketsLast12.js